module.exports = __webpack_public_path__ + "media/assets/community_index/asc-sort-icon-0d52b01cb77e0e70083a6adbadcb19f97ce770f4bff61db0b6c746d2483f9344.png";